import React from "react";
import "./Reasons.css";
import image1 from "../../assets/image1.png";
import image2 from "../../assets/image2.png";
import image3 from "../../assets/image3.png";
import image4 from "../../assets/image4.png";
import tick from "../../assets/tick.png";

const Reasons = () => {
  return (
    <div className="Reasons" id="reasons">
      <div className="left-r">
        <img src={image1} alt="" />
        <img src={image2} alt="" />
        <img src={image3} alt="" />
        <img src={image4} alt="" />
      </div>
      <div className="right-r">
        <span>some reasons</span>
        <div>
          <span className="stroke-text">why</span>
          <span> choose us?</span>
        </div>

        <div className="details-r">
          <div>
            <img src={tick} alt=""></img>
            <span>OVER 30+ EXPERT TRANSLATORS</span>
          </div>
          <div>
            <img src={tick} alt=""></img>
            <span>CLIENT-CENTRIC APPROACH</span>
          </div>
          <div>
            <img src={tick} alt=""></img>
            <span>CULTURAL SENSITIVITY</span>
          </div>
          <div>
            <img src={tick} alt=""></img>
            <span>FAST DELIVERY</span>
          </div>
        </div>
        <span style={{ color: "var(--gray)", fontWeight: "normal" }}>
          WE'LL HAVE YOU SAYING "WOW!" IN MULTIPLE LANGUAGES WITH OUR FAST AND
          ACCURATE TRANSLATIONS. <br />
          <br />
          AND YES, THAT INCLUDES KLINGTON {"("}IF YOU'RE INTO THAT KIND OF THING
          {")"}
        </span>
      </div>
    </div>
  );
};

export default Reasons;
